export function ConnectGuideAndroid() {
  return (
    <svg viewBox="0 0 240 320" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* Phone frame */}
      <rect x="10" y="10" width="220" height="300" rx="12" ry="12" fill="#202124" />
      <rect x="18" y="22" width="204" height="276" rx="6" ry="6" fill="#fafafa" />
      {/* App bar */}
      <rect x="18" y="22" width="204" height="64" rx="6" fill="#1a73e8" />
      <rect x="18" y="50" width="204" height="36" fill="#1a73e8" />
      <text x="44" y="75" fontSize="13" fontWeight="500" fill="#ffffff">WLAN</text>
      <text x="24" y="75" fontSize="16" fill="#ffffff">←</text>
      {/* WLAN toggle */}
      <rect x="18" y="86" width="204" height="40" fill="#ffffff" />
      <text x="30" y="111" fontSize="12" fill="#202124">WLAN verwenden</text>
      <rect x="178" y="95" width="34" height="20" rx="10" fill="#1a73e8" />
      <circle cx="201" cy="105" r="9" fill="#ffffff" />
      <line x1="18" y1="126" x2="222" y2="126" stroke="#e0e0e0" strokeWidth="0.5" />
      {/* Saved networks */}
      <rect x="18" y="126" width="204" height="22" fill="#fafafa" />
      <text x="30" y="141" fontSize="10" fill="#5f6368">GESPEICHERTE NETZWERKE</text>
      {/* Network rows */}
      <rect x="18" y="148" width="204" height="40" fill="#ffffff" />
      <rect x="18" y="148" width="204" height="40" fill="#e8f0fe" />
      <text x="56" y="168" fontSize="12" fill="#202124">Dein-WLAN</text>
      <text x="56" y="182" fontSize="10" fill="#5f6368">Gesichert</text>
      <circle cx="36" cy="168" r="10" fill="#1a73e8" opacity="0.2" />
      <text x="36" y="172" textAnchor="middle" fontSize="12" fill="#1a73e8">📶</text>
      <line x1="18" y1="188" x2="222" y2="188" stroke="#e0e0e0" strokeWidth="0.5" />
      <rect x="18" y="188" width="204" height="40" fill="#ffffff" />
      <text x="56" y="208" fontSize="12" fill="#202124">Dein-WLAN-5G</text>
      <text x="56" y="222" fontSize="10" fill="#5f6368">Gesichert</text>
      <polygon points="228,168 240,161 240,175" fill="#34c759" />
    </svg>
  );
}
